let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Smxy")).then(() => parcelRequire('3SkEw'));